// extracted by mini-css-extract-plugin
module.exports = {"product":"RecentlySearchedProduct_product__3pk4k","productDescription":"RecentlySearchedProduct_productDescription__2xZX-"};